"use strict";

if (document.querySelector('.home-slider')) {
  var thumbsSwiper = [];
  var sliderSwiper = [];
  document.querySelectorAll('.home-thumbs').forEach(function (item, index) {
    var thumbs = item.querySelector('.home-thumbs .swiper-container');
    var speed = thumbs.dataset.speed;
    thumbsSwiper[index] = new Swiper(thumbs, {
      direction: "vertical",
      allowTouchMove: false,
      spaceBetween: 14,
      slidesPerView: 3,
      pagination: false,
      loop: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: speed ? speed : '7000'
      }
    });
  });
  document.querySelectorAll('.home-slider').forEach(function (item, index) {
    var slider = item.querySelector('.home-slider .swiper-container');
    var speed = slider.dataset.speed;
    sliderSwiper[index] = new Swiper(slider, {
      slidesPerView: 1,
      pagination: false,
      loop: false,
      lazy: {
        loadPrevNext: true
      },
      thumbs: {
        swiper: thumbsSwiper[index],
        autoScrollOffset: 1
      },
      autoplay: {
        delay: speed ? speed : '7000'
      },
      on: {
        init: function init() {
          progressBar(slider);
        },
        slideChangeTransitionEnd: function slideChangeTransitionEnd() {
          this.autoplay.start();
          progressBar(slider);
        },
        slideResetTransitionEnd: function slideResetTransitionEnd() {
          this.autoplay.start();
          progressBar(slider);
        },
        resize: function resize() {
          this.autoplay.start();
          progressBar(slider);
        }
      }
    });
  });
}

function progressBar(el) {
  el.querySelector('.swiper-progressbar').classList.remove('active');
  setTimeout(function () {
    el.querySelector('.swiper-progressbar').classList.add('active');
  }, 100);
}